import React, { Component } from "react"
import { Container, Row, Col, Collapse, Button } from "reactstrap"
import { withTranslation } from 'react-i18next'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { Link } from 'react-router-dom'
import i18n from 'i18next'

import { FaPlusCircle, FaMinusCircle, FaSearch } from 'react-icons/fa'


import analyseMetaGeno from "../../images/microbiote/Analyse-Metagenomique-shotgun-du-microbiote-intestinal-Nahibu.png"
import microbioteImg from "../../images/microbiote/micro1.png"
import microbioteImg2 from "../../images/microbiote/micro2.png"
import microbioteImg3 from "../../images/microbiote/micro3.png"
import humanAndBacteriaImg from "../../images/microbiote/human-and-bacteria.png"
import MuscleBlue from "../../images/microbiote/muscle-blue.png"
import MuscleGrey from "../../images/microbiote/muscle-grey.png"
import BrainBlue from "../../images/microbiote/brain-blue.png"
import BrainGrey from "../../images/microbiote/brain-grey.png"
import GutBlue from "../../images/microbiote/gut-blue.png"
import GutGrey from "../../images/microbiote/gut-grey.png"
import ImuneBlue from "../../images/microbiote/imune-blue.png"
import ImuneGrey from "../../images/microbiote/imune-grey.png"

class MicrobioteIntestinal extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isOpen: "isOpen1",
      functionDisplayed: "gut",
    }
    this.toggle = this.toggle.bind(this)
    this.toggleFunction = this.toggleFunction.bind(this)
  }

  toggle(event) {
    this.setState({
      isOpen: event.target.id === this.state.isOpen ? null : event.target.id
    })
  }

  toggleFunction(event) {
    // alert (event.target.id)
    this.setState({
      functionDisplayed: event.target.id
    })
  }

  getFunctionText(func) {
    const t = this.props.t

    if (func === "gut") {
      return (
        <div>
          <p>{t("microbiota|Le microbiote intestinal participe à la digestion, notamment de certaines fibres qui sont autrement indigestibles.")}</p>
          <p>{t("microbiota|Les bactéries intestinales fournissent des enzymes pour dégrader ces composés de notre alimentation. Les principaux produits issus de cette fermentation sont les acides gras à chaîne courte et les gaz.")}</p>
          <p>{t("microbiota|La flore intestinale participe également à la production de certaines vitamines, notamment les vitamines B, et à la satiété.")}</p>
        </div>
      )
    }
    if (func === "brain") {
      return (
        <div>
          <p>{t("microbiota|Le microbiote intestinal active le système nerveux entérique, participant ainsi à la motilité intestinale.")}</p>
          <p>{t("microbiota|La flore intestinale participe à la santé mentale en jouant un rôle notamment dans le stress, le sommeil et la dépression, grâce aux composés produits lors de la fermentation des résidus alimentaires.")}</p>
        </div>
      )
    }
    if (func === "muscle") {
      return (
        <div>
          <p>{t("microbiota|Le microbiote intestinal produit des acides gras à chaîne courte, principalement l’acétate, le propionate et le butyrate, à partir de certaines fibres.")}</p>
          <p>{t("microbiota|Ces composés pénètrent dans les cellules intestinales de l’hôte et peuvent produire des effets sur l’organisme de l’hôte.")}</p>
          <p>{t("microbiota|Les bactéries intestinales participent également au métabolisme des médicaments et au développement des tissus.")}</p>
        </div>
      )
    }
    if (func === "imune") {
      return (
        <div>
          <p>{t("microbiota|Le microbiote intestinal participe à la résistance à la colonisation de notre intestin par des organismes potentiellement pathogènes.")}</p>
          <p>{t("microbiota|Il contribue également à la fonction barrière (barrière entre la lumière intestinale et nos cellules épithéliales). La détérioration de la fonction barrière engendre une inflammation.")}</p>
          <p>{t("microbiota|La flore intestinale joue ainsi un rôle-clé dans l’équilibre immunitaire et influence la susceptibilité à de nombreuses maladies immunes.")}</p>
        </div>
      )
    }
  }

  getFunctionTitle(func) {
    const t = this.props.t
    if (func === "gut") {
      return t("microbiota|Une fonction digestive")
    }
    if (func === "brain") {
      return t("microbiota|Une fonction cérébrale")
    }
    if (func === "muscle") {
      return t("microbiota|Une fonction métabolique")
    }
    if (func === "imune") {
      return t("microbiota|Une fonction immunitaire")
    }
  }

  getFunctionIcon(func) {
    if (func === "gut") {
      return GutBlue
    }
    if (func === "brain") {
      return BrainBlue
    }
    if (func === "muscle") {
      return MuscleBlue
    }
    if (func === "imune") {
      return ImuneBlue
    }
  }


  render() {
    const t = this.props.t
    const language = i18n.language ? (i18n.language.startsWith("fr") ? "fr" : i18n.language.startsWith("en") ? "en" : 'es') : undefined
    const langSubPath = language === "en" ? "/en" : language === "es" ? "/es" : ""

    return (
      <>

        {/* A quoi sert le microbiote intestinal ? */}
        <div className="px-3 px-md-0">
        <Container className="my-5 py-5">
          <h2 className="mb-5 second-title dark-blue small-underline">{t("microbiota|À quoi sert le microbiote intestinal ?")}</h2>
          {/* Mobile : icon on one row */}
          <div className="mobile-only">
            <Row>
              <Col><LazyLoadImage onClick={this.toggleFunction} id="gut" className="toggle-div center" alt={t("microbiota|Fonction digestive")} src={this.state.functionDisplayed === "gut" ? GutBlue : GutGrey} width="100%" /></Col>
              <Col><LazyLoadImage onClick={this.toggleFunction} id="muscle" className="toggle-div center" alt={t("microbiota|Fonction métabolique")} src={this.state.functionDisplayed === "muscle" ? MuscleBlue : MuscleGrey} width="100%" /></Col>
              <Col><LazyLoadImage onClick={this.toggleFunction} id="brain" className="toggle-div center" alt={t("microbiota|Fonction cérébrale")} src={this.state.functionDisplayed === "brain" ? BrainBlue : BrainGrey} width="100%" /></Col>
              <Col><LazyLoadImage onClick={this.toggleFunction} id="imune" className="toggle-div center" alt={t("microbiota|Fonction immunitaire")} src={this.state.functionDisplayed === "imune" ? ImuneBlue : ImuneGrey} width="100%" /></Col>
            </Row>
          </div>
          {/* End of mobile icons */}

          {/* Desktop view */}
          <Row>
            <Col>
              <Row>
                <Col md={2}><LazyLoadImage className="center desktop-only" alt={t("microbiota|Analyse microbiote")} src={this.getFunctionIcon(this.state.functionDisplayed)} width="100%" /></Col>
                <Col md={10}><h3 className="pt-3 light-blue">{this.getFunctionTitle(this.state.functionDisplayed)}</h3></Col>
              </Row>
              <div className="mt-5 text-justify">
                {this.getFunctionText(this.state.functionDisplayed)}
              </div>
            </Col>
            <Col className="desktop-only">
              <Row>
                <Col>
                  <Row className="mb-5"><LazyLoadImage onClick={this.toggleFunction} id="gut" className="toggle-div center" alt="Fonction digestive" src={this.state.functionDisplayed === "gut" ? GutBlue : GutGrey} width="70%" /></Row>
                  <Row><LazyLoadImage onClick={this.toggleFunction} id="brain" className="toggle-div center" alt={t("microbiota|Fonction métabolique")} src={this.state.functionDisplayed === "brain" ? BrainBlue : BrainGrey} width="70%" /></Row>
                </Col>
                <Col>
                  <LazyLoadImage className="center" alt="Microbiote intestinal humain" src={humanAndBacteriaImg} width="100%" />
                </Col>
                <Col>
                  <Row className="mb-5"><LazyLoadImage onClick={this.toggleFunction} id="muscle" className="toggle-div center" alt="Fonction cérébrale" src={this.state.functionDisplayed === "muscle" ? MuscleBlue : MuscleGrey} width="70%" /></Row>
                  <Row><LazyLoadImage onClick={this.toggleFunction} id="imune" className="toggle-div center" alt={t("microbiota|Fonction immunitaire")} src={this.state.functionDisplayed === "imune" ? ImuneBlue : ImuneGrey} width="70%" /></Row>
                </Col>
              </Row>
            </Col>
          </Row>
          {/* End of desktop view */}
        </Container>
        </div>

        

        {/* A la rencontre de votre microbiote */}
        <div className="gradiant-bot-gray  px-3 px-md-0">
          <Container className="my-5 py-5">
            <h2 className="mb-5 second-title dark-blue small-underline">{t("microbiota|À la rencontre de votre microbiote")}</h2>
            <Row>
              <Col className="pr-5 margin-auto" md={7}>
                <div className="toggle-div h3-override">
                  <p id="isOpen1" onClick={this.toggle} className="dark-blue">{this.state.isOpen === "isOpen1" ? <FaMinusCircle id="isOpen1" onClick={this.toggle} size={20}  className="fix-icon-pad"/> : <FaPlusCircle id="isOpen1" onClick={this.toggle} size={20} className="fix-icon-pad"/>} {t("microbiota|Qu'est-ce que le microbiote intestinal ?")}</p>
                </div>
                <Collapse isOpen={this.state.isOpen === "isOpen1"}>
                  <div className="text-justify">
                    <p>{t("microbiota|Le microbiote intestinal, anciennement appelé flore intestinale, est un organe de près de 2 kg situé dans l’intestin.")}</p>
                    <p>{t("microbiota|Constitué de 100 000 milliards de bactéries, il représente un écosystème extrêmement riche, varié, évolutif et surtout propre à chaque individu.")}</p>
                    <p>{t("Il est composé en moyenne de 3,3 millions de gènes.")}</p>
                  </div>
                </Collapse>

                <div className="toggle-div h3-override">
                  <p id="isOpen2" onClick={this.toggle} className="dark-blue">{this.state.isOpen === "isOpen2" ? <FaMinusCircle id="isOpen2" onClick={this.toggle} size={20} className="fix-icon-pad"/> : <FaPlusCircle id="isOpen2" onClick={this.toggle} size={20}  className="fix-icon-pad"/>} {t("microbiota|Qu'est-ce qui influence la composition de notre microbiote intestinal ?")}</p>
                </div>
                <Collapse isOpen={this.state.isOpen === "isOpen2"}>
                  <div className="text-justify">
                    <p>{t("microbiota|Chaque microbiote est unique et les grandes bases de sa composition bactérienne sont fixées à l’âge de 3 ans. Les recherches menées observent que les individus conservent un ensemble d’espèces en grandissant.")}</p>
                    <p>{t("microbiota|Par ailleurs, comme tout écosystème, le microbiote intestinal est influencé par de multiples facteurs : la naissance, le mode de vie, l’environnement, la pratique d’une activité sportive, la prise de médicaments ou d’antibiotiques, le stress, le sommeil et bien sûr l’alimentation.")}</p>
                    <p>{t("microbiota|L’abondance des espèces bactériennes présentes peut évoluer selon ces facteurs au cours du temps.")}</p>
                  </div>
                </Collapse>


                <div className="toggle-div h3-override">
                  <p id="isOpen3" onClick={this.toggle} className="dark-blue">{this.state.isOpen === "isOpen3" ? <FaMinusCircle id="isOpen3" onClick={this.toggle} size={20} className="fix-icon-pad"/> : <FaPlusCircle id="isOpen3" onClick={this.toggle} size={20} className="fix-icon-pad"/>} {t("microbiota|En quoi la composition de notre microbiote et sa diversité est importante ?")}</p>
                </div>
                <Collapse isOpen={this.state.isOpen === "isOpen3"}>
                  <div className="text-justify">
                    <p className="">{t("microbiota|La composition de notre microbiote intestinal affecte certaines fonctions telles que le système immunitaire, la digestion, les ballonnements et gaz, les capacités cognitives et mémoire ou encore la qualité du sommeil.")}</p>
                    <p>{t("Un microbiote diversifié est donc bénéfique à une bonne santé et un bien-être optimal.")}</p>
                  </div>
                </Collapse>
              </Col>
              <Col className="" md={5}>
                <LazyLoadImage className="center" alt={t("microbiota|Analyse microbiote")} src={this.state.isOpen === "isOpen2" ? microbioteImg2 : this.state.isOpen === "isOpen3" ? microbioteImg3 : microbioteImg} width="100%" />
              </Col>
            </Row>
          </Container>
        </div>

        {/* Découvrez la composition de son microbiote */}
        <div className="px-3 px-md-0">
          <Container className="my-5 py-5">
            <h2 className="mb-5 second-title center dark-blue text-left small-underline">{t("microbiota|Et si tout commençait dans votre ventre ?")}</h2>
            <Row className="d-flex flex-column-reverse flex-md-row align-items-center">
              <Col className="margin-auto center mb-4 mb-md-0" md={4}>
                <LazyLoadImage className="center img-fluid pt-4 pt-md-0" alt={t("microbiota|Analyse microbiote")} src={analyseMetaGeno} width="80%" />
              </Col>
              <Col className="pr-lg-5 text-left px-md-5" md={8}>
                <div className="description-text">
                  <p>{t("microbiota|text-1-microbiota")}</p>
                  <p>{t("microbiota|text-2-microbiota")}</p>
                  <ul>
                    <li>{t("microbiota|text-2-l2-microbiota")}</li>
                    <li>{t("microbiota|text-2-l1-microbiota")}</li>
                  </ul>
                  <p>{t("microbiota|text-3-microbiota")}</p>
                </div>
                <Link className="light-blue" to={langSubPath + "/" + t("path|produits") + "/"}><Button className="btn-nah mt-3" size="sm"><FaSearch className="fix-icon-pad mr-2"/>{t("consulting|Découvrir mon microbiote")}</Button></Link>
              </Col>
            </Row>
          </Container>
        </div>







      </>
    )
  }
}

export default withTranslation()(MicrobioteIntestinal)
